import React from 'react';
import Box from '../Box/Box';
import ActionIcons from './ActionIcons';

type THeartIcon = {
  isFavorite?: boolean;
  onClick?: () => void;
  tabIndex?: string;
  className?: string;
  alwaysVisible?: boolean;
};

function getFavoriteData(isFavorite: boolean) {
  if (isFavorite) {
    return {
      icon: 'heart_filled',
      ariaLabel: 'Favorite',
      color: 'signal-error-default',
    };
  }
  return {
    icon: 'heart',
    ariaLabel: 'Unfavorite',
    color: '',
  };
}

const HeartIcon = ({
  isFavorite = false,
  onClick = () => {},
  tabIndex,
  className = '',
  alwaysVisible = false,
}: THeartIcon) => {
  const { icon, ariaLabel, color } = getFavoriteData(isFavorite);
  const boxClassName = alwaysVisible ? 'hz-Image-icons hz-Image-icons--always-visible' : 'hz-Image-icons';

  return (
    <Box name="image-Action-icons" as="div" className={boxClassName}>
      <ActionIcons
        icon={icon}
        onClick={onClick}
        tabIndex={tabIndex}
        className={className}
        ariaLabel={ariaLabel}
        color={color}
      />
    </Box>
  );
};

export default HeartIcon;
